module.exports = __webpack_public_path__ + "static/media/mwm-team.31522068.jpg";